module.exports = __webpack_public_path__ + "img/brand_08.2f3ff899.png";